import { render, staticRenderFns } from "./PortWriteBody.vue?vue&type=template&id=4685ffd7&scoped=true"
import script from "./PortWriteBody.vue?vue&type=script&lang=js"
export * from "./PortWriteBody.vue?vue&type=script&lang=js"
import style0 from "./PortWriteBody.vue?vue&type=style&index=0&id=4685ffd7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4685ffd7",
  null
  
)

export default component.exports